module.exports = __webpack_public_path__ + "img/login.747ffcef.png";